/** Shared visuals + ordering for App Roles / Groups admin lists (User Settings). */

export const RBAC_CARD_ACCENTS = [
  { border: '#6366f1', bg: 'rgba(99, 102, 241, 0.07)' },
  { border: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.07)' },
  { border: '#ec4899', bg: 'rgba(236, 72, 153, 0.07)' },
  { border: '#14b8a6', bg: 'rgba(20, 184, 166, 0.07)' },
  { border: '#f59e0b', bg: 'rgba(245, 158, 11, 0.08)' },
  { border: '#3b82f6', bg: 'rgba(59, 130, 246, 0.07)' },
  { border: '#10b981', bg: 'rgba(16, 185, 129, 0.07)' },
  { border: '#ef4444', bg: 'rgba(239, 68, 68, 0.06)' },
];

export function rbacAccentAt(index) {
  return RBAC_CARD_ACCENTS[Math.abs(index) % RBAC_CARD_ACCENTS.length];
}

export function sortRolesForList(roles) {
  return [...roles].sort((a, b) => {
    const refA = (a.reference_code || '').toString();
    const refB = (b.reference_code || '').toString();
    if (refA && refB && refA !== refB) return refA.localeCompare(refB);
    if (refA && !refB) return -1;
    if (!refA && refB) return 1;
    return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' });
  });
}

export function sortGroupsForList(groups) {
  return [...groups].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
  );
}
